import { zodRequiredField } from '@/shared/config/zod/schema'
import { z } from 'zod'

const CreateHypothesisSchema = z.object({
  mark: z.object({
    id: z.number(),
    name: zodRequiredField(),
  }),
  kind: z.object({
    id: z.number(),
    name: zodRequiredField(),
  }),
  priority: z.object({
    id: z.number(),
    name: zodRequiredField(),
  }),
  markType: z.object({
    id: z.number(),
    mark_type: zodRequiredField().optional(),
    mark_type1: zodRequiredField().optional(),
    mark_type2: zodRequiredField().optional(),
    mark_type3: zodRequiredField().optional(),
  }),
  tool: z.object({
    id: z.number(),
    name: zodRequiredField(),
    tool: zodRequiredField(),
    active: zodRequiredField(),
  }),
  status: z.null(),
  processStatus: z.null(),
  isSuccess: z.null(),
  premise: zodRequiredField(),
  expectedResult: zodRequiredField(),
  script: zodRequiredField(),
  planningResult: zodRequiredField(),
  fact: z.null(),
  conclusions: z.null(),
  dateRangeStart: zodRequiredField(),
  dateRangeEnd: zodRequiredField(),
  userFunnelStep: z.null(),
  growthPointId: z.number(),
  userTaskId: z.number(),
  dateRange: z.object({
    start: zodRequiredField(),
    end: zodRequiredField(),
  }),
})

const CreateHypothesisDtoSchema = z.object({
  mark: z.object({
    id: z.number(),
    name: zodRequiredField(),
  }),
  kind: z.object({
    id: z.number(),
    name: zodRequiredField(),
  }),
  priority: z.object({
    id: z.number(),
    name: zodRequiredField(),
  }),
  mark_type: z.object({
    id: z.number(),
    mark_type: zodRequiredField(),
    mark_type1: zodRequiredField(),
    mark_type2: zodRequiredField(),
    mark_type3: zodRequiredField(),
  }),
  tool: z.object({
    id: z.number(),
    name: zodRequiredField(),
    tool: zodRequiredField(),
    active: zodRequiredField(),
  }),
  status: z.null(),
  process_status: z.null(),
  is_success: z.boolean(),
  premise: zodRequiredField(),
  expected_result: zodRequiredField(),
  script: zodRequiredField(),
  planing_result: zodRequiredField(),
  fact: z.null(),
  conclusions: z.null(),
  date_range_start: zodRequiredField(),
  date_range_end: zodRequiredField(),
  user_funnel_step: z.null(),
  growth_point_id: z.number(),
  user_task_id: z.number(),
})

const CreateHypothesisResponseSchema = CreateHypothesisDtoSchema

export { CreateHypothesisDtoSchema, CreateHypothesisSchema, CreateHypothesisResponseSchema }
